var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 8.00055C14.0004 11.3131 11.315 13.9984 8.0025 13.9984C4.68996 13.9984 2.00462 11.3131 2.00462 8.00055C2.00462 4.68801 4.68996 2.00267 8.0025 2.00267C11.315 2.00267 14.0004 4.68801 14.0004 8.00055Z",
    stroke: "#61AEA0",
    strokeWidth: 1.33346,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00253 7.33222C7.82579 7.33222 7.65628 7.40243 7.53131 7.5274C7.40633 7.65238 7.33612 7.82188 7.33612 7.99862V10.6642C7.33612 10.841 7.40633 11.0105 7.53131 11.1355C7.65628 11.2604 7.82579 11.3306 8.00253 11.3306C8.17927 11.3306 8.34877 11.2604 8.47375 11.1355C8.59872 11.0105 8.66893 10.841 8.66893 10.6642V7.99862C8.66893 7.82188 8.59872 7.65238 8.47375 7.5274C8.34877 7.40243 8.17927 7.33222 8.00253 7.33222ZM8.25576 4.71991C8.09352 4.65326 7.91154 4.65326 7.74929 4.71991C7.66749 4.75163 7.59276 4.79919 7.52938 4.85986C7.47052 4.92463 7.42318 4.99901 7.38944 5.07977C7.35213 5.15886 7.33387 5.24559 7.33612 5.333C7.33562 5.42071 7.35243 5.50765 7.38559 5.58884C7.41875 5.67003 7.46762 5.74388 7.52938 5.80615C7.59416 5.86501 7.66854 5.91235 7.74929 5.94609C7.85025 5.98757 7.95985 6.00362 8.06847 5.99282C8.17708 5.98202 8.28137 5.94471 8.37219 5.88417C8.46301 5.82362 8.53756 5.7417 8.5893 5.64559C8.64104 5.54949 8.66839 5.44215 8.66893 5.333C8.66648 5.15656 8.59745 4.98756 8.47567 4.85986C8.4123 4.79919 8.33756 4.75163 8.25576 4.71991Z",
    fill: "#61AEA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8a1b9b0d8f74a3fce75949613b9f145f.svg";
export { ForwardRef as ReactComponent };